import type { ComponentProps } from 'react';

export function WarningSolidIcon(props: ComponentProps<'svg'>) {
  return (
    <svg
      aria-hidden='true'
      fill='currentColor'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M12.87 3.5a1 1 0 0 0-1.74 0L2.28 19a1 1 0 0 0 .87 1.5h17.7a1 1 0 0 0 .87-1.5L12.87 3.5ZM12 8a1 1 0 0 1 1 1v5a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1Zm0 10.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z' />
    </svg>
  );
}
